import { Store } from 'lucide-react'

import routes from 'constants/routes'
import type { Capabilities } from '../../../utils/capabilities'
import LocationTenants from '../navPages/LocationTenants'
import getLocationRoutes from './getLocationRoutes'

/**
 * A center's tabs (Retail Center or Commercial Center): every tab a location
 * has, plus Tenants after Projects.
 *
 * Built FROM getLocationRoutes rather than as its own list (MYD-516). The
 * separate list had drifted: centers had no Documents or Reports tab, showed
 * Financials to partners who may not see financials, and rendered the edit
 * screen without the location it needs. Deriving it means a tab added to
 * locations reaches centers too.
 */
const getLocationCenterRoutes = (id: string, capabilities?: Capabilities) => {
	const locationRoutes = getLocationRoutes(id, capabilities)
	const tenants = {
		linkText: 'Tenants',
		linkTo: `${routes.LOCATIONS}/${id}/tenants`,
		linkPattern: `${routes.LOCATIONS}/:id/tenants`,
		icon: Store,
		component: LocationTenants,
	}
	const afterProjects = locationRoutes.findIndex((route: any) => route.linkText?.trim() === 'Projects') + 1
	return [...locationRoutes.slice(0, afterProjects), tenants, ...locationRoutes.slice(afterProjects)]
}

export default getLocationCenterRoutes
